/**
 * OutletDJ Favorites - lightweight, native (no third-party app), phase 1
 * localStorage-only wishlist. Stores product handles only (no sensitive
 * data). Product cards, the product page, and the header all read/write
 * through this single module so they stay in sync without a page reload.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'outletdj_favorites';
  var EVENT_NAME = 'favorites:changed';

  function readFavorites() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeFavorites(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // Private browsing / quota / storage disabled - the feature simply
      // won't persist for this visitor; never throw or break the page.
    }
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { handles: handles } }));
  }

  function isFavorite(handle) {
    return readFavorites().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var favs = readFavorites();
    var idx = favs.indexOf(handle);
    if (idx === -1) {
      favs.push(handle);
    } else {
      favs.splice(idx, 1);
    }
    writeFavorites(favs);
    return favs.indexOf(handle) !== -1;
  }

  function removeFavorite(handle) {
    var favs = readFavorites().filter(function (h) {
      return h !== handle;
    });
    writeFavorites(favs);
  }

  function updateHeartButton(btn, saved) {
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Remove from favourites' : 'Add to favourites');
    btn.classList.toggle('favorite-heart--saved', saved);
    var label = btn.querySelector('[data-favorite-heart-label]');
    if (label) {
      label.textContent = saved ? 'Saved' : 'Add to Favourites';
    }
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-favorites-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-favorites-link]').forEach(function (el) {
      el.setAttribute('aria-label', count > 0 ? 'Favourites (' + count + ' saved)' : 'Favourites');
    });
  }

  function syncAllHearts() {
    var favs = readFavorites();
    document.querySelectorAll('.favorite-heart[data-product-handle]').forEach(function (btn) {
      updateHeartButton(btn, favs.indexOf(btn.dataset.productHandle) !== -1);
    });
    updateHeaderCount(favs.length);
  }

  function onHeartClick(event) {
    var btn = event.target.closest('.favorite-heart');
    if (!btn) return;
    // Hearts sit on top of a full-card link (product cards) or inline
    // near Add to Cart (product page) - never let the click bubble into
    // a card-navigation or purchase handler.
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    var saved = toggleFavorite(handle);
    document.querySelectorAll('.favorite-heart[data-product-handle="' + CSS.escape(handle) + '"]').forEach(function (b) {
      updateHeartButton(b, saved);
      b.classList.add('favorite-heart--pulse');
      window.setTimeout(function () {
        b.classList.remove('favorite-heart--pulse');
      }, 260);
    });
    document.dispatchEvent(new CustomEvent('favorites:item-changed', { detail: { handle: handle, saved: saved } }));
  }

  document.addEventListener('click', onHeartClick);
  document.addEventListener(EVENT_NAME, function (e) {
    updateHeaderCount(e.detail && e.detail.handles ? e.detail.handles.length : readFavorites().length);
  });

  function init() {
    syncAllHearts();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API - used by the dedicated favorites page to fetch and render
  // saved products, and available for any future extension (e.g.
  // customer-account syncing) without touching the storage layer above.
  window.OutletDJFavorites = {
    STORAGE_KEY: STORAGE_KEY,
    EVENT_NAME: EVENT_NAME,
    readFavorites: readFavorites,
    isFavorite: isFavorite,
    toggleFavorite: toggleFavorite,
    removeFavorite: removeFavorite,
    syncAllHearts: syncAllHearts,
  };
})();
